import React, { useState } from "react";

const AssignRole = () => {
  const [users, setUsers] = useState([
    { id: 1, name: "John Doe", role: "" },
    { id: 2, name: "Jane Smith", role: "" },
    { id: 3, name: "Bob Johnson", role: "" },
  ]); // Mock user data

  const roles = ["Admin", "Manager", "Staff", "Viewer"]; // Available roles

  const handleRoleChange = (userId, role) => {
    const updatedUsers = users.map((user) =>
      user.id === userId ? { ...user, role } : user
    );
    setUsers(updatedUsers);
  };

  const handleSave = () => {
    // Save to localStorage for now (replace with API integration later)
    localStorage.setItem("userRoles", JSON.stringify(users));
    alert("User roles saved successfully!");
  };

  return (
    <div className="p-4 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Assign User Roles</h1>
      <table className="w-full bg-white rounded-lg shadow-md">
        <thead>
          <tr className="bg-gray-200 text-left">
            <th className="py-2 px-4">User Name</th>
            <th className="py-2 px-4">Role</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="border-t">
              <td className="py-2 px-4">{user.name}</td>
              <td className="py-2 px-4">
                <select
                  value={user.role}
                  onChange={(e) => handleRoleChange(user.id, e.target.value)}
                  className="border rounded p-2"
                >
                  <option value="">Select Role</option>
                  {roles.map((role, index) => (
                    <option key={index} value={role}>
                      {role}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button
        onClick={handleSave}
        className="mt-4 bg-[#068800] text-white px-4 py-2 rounded"
      >
        Save Roles
      </button>
    </div>
  );
};

export default AssignRole;
